/**
 * @file
 * Behaviors for the primary navigation.
 */
/* eslint-disable max-len */

(function (Drupal) {

  Drupal.behaviors.primarynav = {
    attach: function (context) {
      once('primaryMenu', '.primary-nav', context).forEach(
        function (menuElement) {
          // Check if an element has a specific class.
          function hasClass(element, className) {
            return element.classList.contains(className);
          }

          // Debounce function
          function debounce(func, delay) {
            let timer;
            return function () {
              const fnContext = this;
              const args = arguments;
              clearTimeout(timer);
              timer = setTimeout(() => func.apply(fnContext, args), delay);
            };
          }

          let activeModeListeners = [];

          function detachActiveListeners() {
            // Loop through the currently active event listenres and remove them.
            activeModeListeners.forEach(listener => {
              const { element, event, func } = listener;
              element.removeEventListener(event, func);
            });
            activeModeListeners = [];
          }

          // Desktop menu behaviors
          function desktopBehavior(menuElement) {
            const tabActiveClass = 'tabActive';
            const menuActiveClass = 'menuActive';
            const subMenuActiveSelector = '.primary-nav--sub.nav-desktop.menuActive';

            // The top level menu items.
            const tabElements = menuElement.querySelectorAll('.primary-nav--title.tier-one');

            tabElements.forEach(function (tab) {
              const desktopClickListener = function (e) {
                e.stopPropagation();
                // We go up to the parent node, and then find the menu associated with the clicked button.
                const tierOne = this.parentNode.querySelector('.primary-nav--sub.nav-desktop');
                // Select the top level menu item that is currently open.
                const tabActive = menuElement.querySelector(`.${tabActiveClass}`);
                // Select the menu that is currently displayed.
                const menuActive = menuElement.querySelector(`.${menuActiveClass}`);

                if (hasClass(this, tabActiveClass)) {
                  // If the clicked element is already active, we remove the active classes from it and its associated menu.
                  // This closes the menu item.
                  this.classList.remove(tabActiveClass);
                  tierOne.classList.remove(menuActiveClass);
                } else {
                  // The below two if statements are to ensure the active classes get removed
                  // from the previously active element when another is clicked.
                  // This avoids a situation where multiple menu items have active styling at the same time.
                  if (tabActive && tabActive !== this) {
                    tabActive.classList.remove(tabActiveClass);
                  }
                  if (menuActive) {
                    menuActive.classList.remove(menuActiveClass);
                  }
                  // Lastly, we add the active classes to the clicked element and its associated menu.
                  this.classList.add(tabActiveClass);
                  tierOne.classList.add(menuActiveClass);
                }
              };

              // Add a click listener to the top level menu items.
              tab.addEventListener('click', desktopClickListener);

              // Add the listener to the activeModeListeners array.
              activeModeListeners.push({
                element: tab,
                event: 'click',
                func: desktopClickListener
              });
            });

            // This function is used to determine if a click event occurred outside of the menu.
            const documentClickListener = function (e) {
              const activeSubMenu = menuElement.querySelector(subMenuActiveSelector);
              // The element that was clicked on
              const clickedElement = e.target;
              // Returns true if the clicked element is inside the menu.
              const isInsideMenu = menuElement.contains(clickedElement);
              // Returns true if the clicked element is within the .primary-nav element
              const isMenuLink = clickedElement.closest('.primary-nav');
              // Returns true if the clicked element is not a link inside the menu, but is another HTML element,
              // such as the link descriptions which are <div> elements.
              const isNonLinkElementInsideMenu = isInsideMenu && !(clickedElement instanceof HTMLAnchorElement);

              // If the click happens outside of the menu or on a menu item...
              if (!isInsideMenu || isMenuLink) {
                // First check if it was a click on an HTML element inside the menu, but not a link.
                // If it is, we return early so the menu stays open in that scenario.
                if (isNonLinkElementInsideMenu) {
                  return;
                }

                // Otherwise, remove all of the active classes to close the menu
                if (activeSubMenu) {
                  activeSubMenu.classList.remove(menuActiveClass);
                }

                const tabActive = menuElement.querySelector(`.${tabActiveClass}`);
                const menuActive = menuElement.querySelector(`.${menuActiveClass}`);

                if (tabActive) {
                  tabActive.classList.remove(tabActiveClass);
                }
                if (menuActive) {
                  menuActive.classList.remove(menuActiveClass);
                }
              }
            };

            // Add this listener to the document and the activeModeListeners array.
            document.addEventListener('click', documentClickListener);

            activeModeListeners.push({
              element: document,
              event: 'click',
              func: documentClickListener
            });
          }

          // Mobile menu behaviors
          function mobileBehavior(menuElement) {
            // The mobile menu element.
            const mobileMenu = menuElement.querySelector('.primary-nav--mobile');
            // The top level menu items.
            const mobileTabElements = menuElement.querySelectorAll('.primary-nav--title.nav-mobile');
            // The "Back to Main Menu" container.
            const backButtonElements = menuElement.querySelectorAll('.primary-nav--mobile-title');
            // The second level menu items.
            const mobileTabSubElements = menuElement.querySelectorAll('.mobile-tier-two');
            // The close button.
            const mobileCloseElements = menuElement.querySelectorAll('.primary-nav--close .icon-close');
            // The container around all of the links in the menu
            const mobileSubMenuElements = menuElement.querySelectorAll('.primary-nav--sub-links');

            mobileTabElements.forEach(function (mobileTab) {
              const mobileTabClickListener = function () {
                // Any time a top level item is clicked, add the active class to its associated, sibling menu.
                this.nextElementSibling.classList.add('active');
              };
              // Add an event listener to each top level menu item and add it to the activeModeListeners array.
              mobileTab.addEventListener('click', mobileTabClickListener);

              activeModeListeners.push({
                element: mobileTab,
                event: 'click',
                func: mobileTabClickListener
              });
            });

            backButtonElements.forEach(function (backButton) {
              const backButtonClickListener = function () {
                // Any time the back button is clicked, remove the active class from the currently displayed menu.
                this.parentElement.classList.remove('active');
              };

              // Add an event listener to the back button and add it to the activeModeListeners array.
              backButton.addEventListener('click', backButtonClickListener);
              activeModeListeners.push({
                element: backButton,
                event: 'click',
                func: backButtonClickListener
              });
            });

            mobileTabSubElements.forEach(function (mobileTabSub) {
              const mobileTabSubClickListener = function () {
                // Any time a second level menu item is clicked, add the active class to its associated, sibling menu.
                this.nextElementSibling.classList.add('active');
              };

              // Add an event listener to each second level menu item and add it to the activeModeListeners array.
              mobileTabSub.addEventListener('click', mobileTabSubClickListener);

              activeModeListeners.push({
                element: mobileTabSub,
                event: 'click',
                func: mobileTabSubClickListener
              });
            });

            mobileCloseElements.forEach(function (mobileClose) {
              const mobileCloseClickListener = function () {
                mobileSubMenuElements.forEach(function (subItem) {
                  // If the close button is clicked, hide all of the sub menus.
                  subItem.classList.toggle('filter-hide');
                });
                // And then hide the menu itself
                mobileMenu.classList.toggle('closed');
                // If the close icon is showing, change it to the menu icon, and vice versa.
                this.textContent = this.textContent === 'close' ? 'menu' : 'close';
              };

              // Add an event listener to the close button and add it to the activeModeListeners array.
              mobileClose.addEventListener('click', mobileCloseClickListener);

              activeModeListeners.push({
                element: mobileClose,
                event: 'click',
                func: mobileCloseClickListener
              });
            });
          }

          // Initially determine the correct behavior to attache based on the initial window width.
          if (window.innerWidth > 991) {
            desktopBehavior(menuElement);
          } else {
            mobileBehavior(menuElement);
          }

          window.addEventListener('resize', debounce(() => {
            // Detaching all previously attached event listeners.
            // This way, we avoid multiple listeners being added as the window is resized. 
            detachActiveListeners();

            // Determine the correct behavior to attach based on the window width, after resize
            if (window.innerWidth > 991) {
              desktopBehavior(menuElement);
            } else {
              mobileBehavior(menuElement);
            }
          }, 150));
        }
      );
    }
  };
})(Drupal);

